/**
 * A module to dynamically change account button links depending on if the user
 * is logged in or not. We have to use this due to static caching.
 */

export default async function init(isGuest: boolean) {
  const registerButtons = document.querySelectorAll('.js-register-button');
  const loginButtons = document.querySelectorAll('.js-login-button');

  const accountLink = isGuest ? '/account/register' : '/account';
  const accountText = isGuest ? 'Register' : 'Account';

  registerButtons.forEach((registerButton) => {
    registerButton.setAttribute('href', accountLink);
    // Preserve arrow SVG if it exists
    const arrow = registerButton.querySelector('svg');
    if (arrow) {
      // Create text node and preserve arrow
      registerButton.innerHTML = '';
      registerButton.appendChild(document.createTextNode(accountText));
      registerButton.appendChild(arrow);
    } else {
      registerButton.innerHTML = accountText;
    }
    registerButton.ariaLabel = isGuest ? 'Register' : 'Account';
  });

  loginButtons.forEach((loginButton) => {
    loginButton.setAttribute('href', isGuest ? '/account/login' : '/account');
    loginButton.innerHTML = isGuest ? 'Login' : 'Account';
    loginButton.ariaLabel = isGuest ? 'Login' : 'Account';
  });
}
